import UrlLocation from 'src/lib/url/UrlLocation'

/** Campaign paths where CMS dark video blocks opt into beige under rebrand (not global). */
export const REBRAND_BEIGE_VIDEO_BLOCK_PATHS = [
  '/campaign/store',
  '/campaign/7news-traveltester',
] as const

function normaliseCampaignPathname(pathname: string): string {
  const withoutLocale = new UrlLocation(pathname).withoutLocale().path
  // Region is the first segment (e.g. /au/...). Paths that already start at /campaign skip that strip.
  const withoutRegion = /^\/campaign(\/|$)/i.test(withoutLocale)
    ? withoutLocale
    : (withoutLocale.replace(/^\/[^/]+/, '') || '/')
  return withoutRegion.replace(/\/+$/, '') || '/'
}

/** Whether this pathname opts into path-scoped beige dark video blocks under rebrand. */
export function isContentfulRebrandBeigeVideoBlockPath(pathname: string): boolean {
  const normalised = normaliseCampaignPathname(pathname).toLowerCase()
  return (REBRAND_BEIGE_VIDEO_BLOCK_PATHS as ReadonlyArray<string>).includes(normalised)
}
